import React from 'react';
import { observer } from 'mobx-react';
import { config } from '../../config.js'

// Icons
import * as icons from '../Icons/Icons';

const Calculator = observer(class Calculator extends React.Component {
  constructor() {
    super();

    // Set the initial state
    this.state = {
      calcType: null,
      initialized: false,
      render: false
    };

    // Limit ClassCalc retries
    this.retryLimit = 20;
    this.i = 0;
  }

  componentDidMount() {
    const { SessionStore } = this.props.store;
    const classCalcScript = document.querySelector('#classCalc-js');

    this.setState({
      calcType: SessionStore.calculator
    });

    if (!classCalcScript) {
      const ccjs = document.createElement('script');
      ccjs.id = 'classCalc-js';
      ccjs.src = 'https://app.classcalc.com/api';
      ccjs.onload = this.renderCalculator;

      document.body.append(ccjs);
    } else {
      this.renderCalculator();
    }
  }

  componentDidUpdate() {
    const { SessionStore } = this.props.store;

    if (SessionStore.calculator !== this.state.calcType && SessionStore.calculator !== 'none') {
      this.setState({
        calcType: SessionStore.calculator,
        render: false
      }, () => {
        this.renderCalculator()
      });
    }
  }

  renderCalculator = () => {
    const { classCalcApiKey } = config;
    const { ClassCalc } = window;
    const { SessionStore } = this.props.store;
    const { userSid } = SessionStore.userData;
    const calcArray = ['scientific-calc', 'graphing-calc', 'matrix-calc', 'four-function-calc'];
    const allowedCalcTypeIndex = calcArray.indexOf(SessionStore.calculator);

    if (allowedCalcTypeIndex > -1) {
      calcArray.splice(allowedCalcTypeIndex, 1);
    }

    if (ClassCalc) {
      if (!this.state.initialized) {
        ClassCalc.init('calculator', {apiKey: classCalcApiKey, userId: userSid});
      }

      this.setState({
        initialized: true
      });

      this.setCalculatorType(calcArray);
    }
  }

  setCalculatorType = calculatorType => {
    const { ClassCalc } = window;

    setTimeout(() => {
      try {
        ClassCalc.controller.disableButtons(calculatorType);
        this.setState({ render: true });
      } catch (e) {
        if (this.i < this.retryLimit) {
          this.setCalculatorType(calculatorType);
          this.i++;
        } else {
          console.error('ClassCalc failed to initialize.');
        }
      }
    }, 100);
  }

  render() {
    const { SessionStore } = this.props.store;
    const { render } = this.state;

    return (
      <div
        className={`modal${
          SessionStore.calculator === 'none' ? ' hidden' : ''
        }`}
      >
        <div className="modal__window">
          <header className="modal__head">
            <button
              className="modal__close"
              onClick={() => SessionStore.calculator = 'none'}
            >
              <icons.iconTimes />
              <span className="meta">Close</span>
            </button>
          </header>

          <div className="calc">
            <div
              className={`calc__body ${
                !render ? ' calc__body--hidden' : ''
              }`}
              id="calculator"
            />

            {!render &&
              <span className="calc__loader loader-bar" />
            }
          </div>
        </div>
      </div>
    )
  }
});

export default Calculator;



// WEBPACK FOOTER //
// ./src/app/components/Common/Calculator.js